export default "__VITE_ASSET__blJ3$2ei__"